import React from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tooltip,
} from "@mui/material";
import { ReactComponent as DownloadIcon } from "images/file-csv.svg";

import * as SC from "./DataGrid.style";
import { customColors } from "models/customColors";

export const DataGridPagination = ({
  totalPages,
  defaultLimit,
  limit,
  currentPage,
  handleChangePage,
  handleChangeRecordsPerPage,
  count,
  disableDownload,
  handleDownload,
}) => (
  <SC.PaginationContainer>
    <Pagination
      count={totalPages}
      page={currentPage}
      onChange={handleChangePage}
      size="small"
    />
    <SC.RecordsPerPageSelector>
      <Select
        value={limit}
        label="Age"
        onChange={handleChangeRecordsPerPage}
        size="small"
        sx={{ backgroundColor: customColors.white, fontSize: "14px" }}
      >
        <MenuItem value={defaultLimit}>{defaultLimit}</MenuItem>
        <MenuItem value={defaultLimit * 2}>{defaultLimit * 2}</MenuItem>
        <MenuItem value={defaultLimit * 4}>{defaultLimit * 4}</MenuItem>
        <MenuItem value={defaultLimit * 8}>{defaultLimit * 8}</MenuItem>
      </Select>
      per page
    </SC.RecordsPerPageSelector>
    <Stack direction="row">
      {disableDownload || count === 0 ? (
        <Box width="15px" />
      ) : (
        <Tooltip title="Download in CSV">
          <IconButton onClick={handleDownload} size="small">
            <DownloadIcon width={"26px"} />
          </IconButton>
        </Tooltip>
      )}
      <SC.RecordsPerPageSelector>{count} records</SC.RecordsPerPageSelector>
    </Stack>
  </SC.PaginationContainer>
);
